'use strict';

import VueCookies from 'vue-cookies';

export default class Auth {

    static get tokenCookieName() {
        return 'dance-crm-user-token';
    }

    static save(token, isRemember = false) {
        VueCookies.set(this.tokenCookieName, token, isRemember === true ? '13h' : 0);
    }

    static getToken() {
        const token = VueCookies.get(this.tokenCookieName);
        return  token ? token : '';
    }

    static check() {
        return VueCookies.isKey(this.tokenCookieName);
    }

    static logout() {
        VueCookies.remove(this.tokenCookieName);
    }

}
